//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';

import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import DataTableLayout from '@/components/_common/Layout/DataTableLayout';
import AvailsScheduleTitleBar from '@/components/Focus/AvailsSchedule/AvailsScheduleTitleBar';
import FiltersContainer from '@/components/Focus/common/FiltersContainer';

const AvailsSchedule = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  useEffect(() => {
    dispatch(setCurrentTable('focusSchedule'));
  }, []);

  return (
    <>
      {currentTableKey === 'focusSchedule' && (
        <DataTableLayout tableKey="focusSchedule">
          <AvailsScheduleTitleBar />
          <FiltersContainer>
            <DataTableFilters disableExportReport />
          </FiltersContainer>
        </DataTableLayout>
      )}
    </>
  );
};

export default AvailsSchedule;
